import { Dialog } from "@kunduz/ui-molecules";
import { ComponentConfig, DropZone, WithPuckProps } from "@measured/puck";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import styles from "./modal.module.scss";

export interface ModalProps {
  show: boolean;
  query_param: string;
  width?: number | string;
  paddingRight?: number;
  paddingLeft?: number;
  paddingTop?: number;
  paddingBottom?: number;
}

const Modal = (props: WithPuckProps<ModalProps>) => {
  const router = useRouter();
  const [render, setRender] = useState(false);

  const { modal } = router.query as any;
  const modalValues = useMemo(() => (modal ? modal.split(",") : []), [modal]);

  useEffect(() => {
    if (modalValues.some((m: string) => props.query_param.includes(m))) {
      setRender(true);
    } else {
      setRender(false);
    }
  }, [modalValues, props.query_param]);

  const onClose = () => {
    setRender(false);

    const cleanPath = window.location.origin + "/" + window.location.pathname;
    router.push(cleanPath, undefined, { shallow: true });
  };

  return (
    <Dialog
      opened={props.editMode ? true : render}
      closeOnClickOutside={!props.editMode}
      withPortal={!props.editMode}
      close={onClose}
      style={{
        width: props.width || "100%",
        paddingRight: props.paddingRight || 0,
        paddingLeft: props.paddingLeft || 0,
        paddingTop: props.paddingTop || 0,
        paddingBottom: props.paddingBottom || 0,
      }}
      withOverlay={!(props.editMode ?? false)}
      contentClassName={classNames({
        [styles.visible]: props.editMode && props.show,
        [styles.hidden]: props.editMode && !props.show,
      })}
    >
      <div>
        <DropZone zone="modalContent" />
      </div>
    </Dialog>
  );
};

export const PuckModal: ComponentConfig<ModalProps> = {
  label: "Modal",
  fields: {
    query_param: {
      label: "Query Parameter",
      type: "text",
    },
    show: {
      label: "Show Modal",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    width: {
      label: "Width",
      type: "text",
    },
    paddingBottom: {
      label: "Padding Bottom",
      type: "number",
    },
    paddingTop: {
      label: "Padding Top",
      type: "number",
    },
    paddingRight: {
      label: "Padding Right",
      type: "number",
    },
    paddingLeft: {
      label: "Padding Left",
      type: "number",
    },
  },
  render: (props) => <Modal {...props} />,
};
